import { render, staticRenderFns } from "./PainterMsgSuperDetails.vue?vue&type=template&id=43b239c1&scoped=true"
import script from "./PainterMsgSuperDetails.vue?vue&type=script&lang=js"
export * from "./PainterMsgSuperDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterMsgSuperDetails.vue?vue&type=style&index=0&id=43b239c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b239c1",
  null
  
)

export default component.exports